import { Person } from '@material-ui/icons';
import { useState } from "react";
import { useDispatch } from 'react-redux';
import setting from '../../assets/setting.png';
import user from '../../assets/user.png';
import { logout } from '../../features/auth/authSlice';

const Userprofile = () => {
  const [isOpen, setOpen] = useState(false);
  const toggleDropdown = () => setOpen(!isOpen);
  const emailId = localStorage.getItem("emailId");
  const dispatch = useDispatch()

  function handleLogout() {
    dispatch(logout());
  };
  return (
    <div className='dropdown'>
      <div className='dropdown-header' onClick={toggleDropdown}>
        <div className='profile-pic'><Person /></div>
        <span>{emailId}</span>
        <i className={`fa fa-chevron-right icon ${isOpen && "open"}`}></i>
      </div>
      <div className={`dropdown-body ${isOpen && 'open'}`}>

        <div className="dropdown-item">
          <img src={user} alt='user profile' />
          <span>Profile</span>
        </div>
        <div className="dropdown-item">
          <img src={setting} alt='user profile' />
          <span>Setting</span>
        </div>
        <div className="dropdown-item" onClick={handleLogout}>
          <span><i className="fa fa-sign-out" aria-hidden="true"></i> Logout</span>
        </div>
      </div>
    </div>
  )
}
export default Userprofile